<ng-template #sponsoredBanner>
  <app-sponsoring-wrapper [sponsorItem]="sponsorItem">
    <app-image-header
      #wrappedComponent
      [bannerId]="_uid"
      [promoImage]="bannerImages"
      [bannerLink]="bannerLink"
      [isExternalLink]="isExternalLink"
      [trackingName]="trackingName"
      [title]="title"
      [sponsorItem]="sponsorItem"
    ></app-image-header>
  </app-sponsoring-wrapper>
</ng-template>

<ng-template #banner>
  <app-image-header
    [bannerId]="_uid"
    [promoImage]="bannerImages"
    [bannerLink]="bannerLink"
    [isExternalLink]="isExternalLink"
    [trackingName]="trackingName"
    [title]="title"
  ></app-image-header>
</ng-template>

<ng-container *ngTemplateOutlet="sponsorItem?.isSponsored ? sponsoredBanner : banner"></ng-container>
